// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"bd0196a7","81":"4b39736e","156":"7d9627b5","235":"f5a65fa0","310":"9ebdb0c0","394":"60154dfe","423":"99e38421","455":"9b5f4ec3","538":"2dfe7d39","725":"5c0a60a9","739":"5c1583dd","853":"51baf98b","860":"0e072018"}[chunkId] + ".chunk.js";
};